<template>
    <div class="mb-4 border-top mt-3 pt-3" >
        <label
            for="status-select"
            class="form-label fs-15 text-success text-uppercase fw-semibold mb-3"
            >{{ $t('time') }}</label
        >
        <br />
        <div class="row g-2 list_filtr" >
            <div class="col-lg-6">
                <div class="form-check mb-2" >
                    <input class="form-check-input" type="radio" @change="change()" name="radioTime" id="all_times" v-model="status" :value="''">
                    <label class="form-check-label" for="all_times">{{ $t('all') }}</label>
                </div>
            </div>
            <template v-for="(value, index) in opt" :key="index" >
                <div class="col-lg-6">
                    <div class="form-check mb-2" >
                        <input class="form-check-input" type="radio" @change="change()" name="radioTime" :id="'time'+index" v-model="status" :value="value.value">
                        <label class="form-check-label" :for="'time'+index">{{ value.name }}</label>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { storeS } from '@/store';

export default {
    data(){
        return {
            status: "",
            opt: [
                {
                    name: this.$t('3MonthsMore'),
                    value: "3MonthsMore",
                },
                {
                    name: this.$t('6MonthsMore'),
                    value: "6MonthsMore",
                },
                {
                    name: this.$t('9MonthsMore'),
                    value: "9MonthsMore",
                },
                {
                    name: this.$t('12MonthsMore'),
                    value: "12MonthsMore",
                },
            ]
        }
    },
    methods: {
        formatDate(date) {
            // Форматувати дату в YYYY-MM-DD
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        change(){
            let startDate = ""
            let endDate = ""
            const today = new Date()
            const pastDate = new Date()

            switch (this.status) {
                case "3MonthsMore":
                    pastDate.setMonth(today.getMonth() - 3)
                    break;
                case "6MonthsMore":
                    pastDate.setMonth(today.getMonth() - 6)
                    break;
                case "9MonthsMore":
                    pastDate.setMonth(today.getMonth() - 9)
                    break;
                case "12MonthsMore":
                    pastDate.setMonth(today.getMonth() - 12)
                    break;
                default:
                    return
            }

            startDate = this.formatDate(pastDate)
            endDate = this.formatDate(today)

            // Передати масив з двома датами [від, до]
            this.$emit('change', 'pr', [startDate, endDate])
        },
    },
    computed: {
        // providers(){
        //     return storeS.providers
        // }
    }
}
</script>